module.exports = __webpack_public_path__ + "static/media/01.fde9b3de.png";